import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from './../store/index.js'

import Top from '@/components/Top' // LP

import Login from '@/components/Login' // ログイン画面
import LoginReminder from '@/components/LoginReminder' // パスワード忘れ: メールアドレス入力画面
import LoginResetPassword from '@/components/LoginResetPassword' // パスワード忘れ: パスワード入力画面
import SignUp from '@/components/SignUp' // 登録画面
import Contact from '@/components/Contact' // お問い合わせ画面

import Mypage from '@/components/Mypage' // マイページ
import ProductDetail from '@/components/ProductDetail' // マイページ
import SellerDetail from '@/components/SellerDetail' // 販売者ページ
import Message from '@/components/Message' // メッセージ

import Search from '@/components/Search' // 検索
import Review from '@/components/Review' // 評価画面

import TestBullet from '@/components/TestBullet' // 試弾申し込み
import Buy from '@/components/Buy' // 購入申し込み

import ProductComment from '@/components/ProductComment' // 商品コメント詳細

import Ranking from '@/components/Ranking' // ランキング
import Article from '@/components/Article' // 企画・特集
import ArticleList from '@/components/ArticleList' // 記事一覧
import ArticleDetail from '@/components/ArticleDetail' // 記事ページ

import PrivacyPolicy from '@/components/PrivacyPolicy' // 利用規約
import TermsOfService from '@/components/TermsOfService' // プライバシーポリシー
import AboutPiachu from '@/components/AboutPiachu' // ピアチュウとは
import SellerRegistration from '@/components/SellerRegistration' // ピアノ販売者の登録について
import GuidelineSeller from '@/components/GuidelineSeller' // ピアノ販売者利用のガイドライン
import GuidelineReview from '@/components/GuidelineReview' // 評価投稿ガイドライン
import ProhibitedActs from '@/components/ProhibitedActs' // ピアチュウで禁止されている行為について
import ChargeUser from '@/components/ChargeUser' // ユーザ利用料について
import GuidelineUser from '@/components/GuidelineUser' // 使い方について
import ChargeSeller from '@/components/ChargeSeller' // ピアノ販売者利用料について

import ManagerInfo from '@/components/ManagerInfo' // 運営
import AdminMessage from '@/components/AdminMessage' // 管理メッセージ
import AdminOrderDetail from '@/components/AdminOrderDetail' // 管理申込詳細

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: Login,
    meta: {
      isPublic: true,
      title: "ログイン - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/reminder',
    component: LoginReminder,
    meta: {
      isPublic: true,
      title: "パスワード再設定 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/reset_password',
    component: LoginResetPassword,
    meta: {
      isPublic: true,
      title: "パスワード再設定 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/sign_up',
    component: SignUp,
    meta: {
      isPublic: true,
      title: "会員登録 - ピアチュウ",
      description: "",
    },
  },
  {
    path: '/contact',
    component: Contact,
    meta: {
      isPublic: true,
      title: "お問い合わせ - ピアチュウ",
      description: "",
    },
  },
  {
    path: '/mypage',
    component: Mypage,
    meta: {
      title: "マイページ - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/search',
    component: Search,
    meta: {
      isPublic: true,
      title: "全国の中古ピアノ一覧 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/ranking',
    component: Ranking,
    meta: {
      isPublic: true,
      title: "ランキング - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/article',
    component: Article,
    meta: {
      isPublic: true,
      title: "中古ピアノの企画・特集記事一覧 - ピアチュウ",
      description: "中古ピアノについて、豆知識や失敗しないためのピアノの選び方、よくあるトラブルなど、中古ピアノ購入前に知っておきたいお役立ち情報を提供します。",
    }
  },
  {
    path: '/article/list/:articles_id',
    component: ArticleList,
    meta: {
      isPublic: true,
      title: "記事一覧 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/article/detail/:article_details_id',
    component: ArticleDetail,
    meta: {
      isPublic: true,
      title: "記事 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/product/:products_id',
    component: ProductDetail,
    meta: {
      isPublic: true,
      title: "商品詳細 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/product_comment/:products_id',
    component: ProductComment,
    meta: {
      // isPublic: true,
      title: "商品コメント詳細 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/test_bullet/:products_id',
    component: TestBullet,
    meta: {
      title: "試弾申し込み - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/buy/:products_id',
    component: Buy,
    meta: {
      title: "購入申し込み - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/seller/:users_id',
    component: SellerDetail,
    meta: {
      isPublic: true,
      title: "販売者ページ - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/message/:users_id/:status/:messages_id',
    component: Message,
    meta: {
      // isPublic: true,
      title: "メッセージ - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/admin/message/:users_id/:status/:messages_id',
    component: AdminMessage,
    meta: {
      // isPublic: true,
      title: "管理メッセージ - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/admin/order/:orders_id',
    component: AdminOrderDetail,
    meta: {
      // isPublic: true,
      title: "管理申込詳細 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/review/:type/:orders_id/:products_id',
    component: Review,
    name: 'review',
    meta: {
      // isPublic: true,
      title: "評価 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/',
    component: Top,
    meta: {
      isPublic: true,
      title: "全国の中古ピアノ、販売店を比較して探せる - ピアチュウ",
      description: "",
    }
  },

  // ぺら
  {
    path: '/privacy_policy',
    component: PrivacyPolicy,
    meta: {
      isPublic: true,
      title: "プライバシーポリシー - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/terms_of_service',
    component: TermsOfService,
    meta: {
      isPublic: true,
      title: "利用規約 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/about_piachu',
    component: AboutPiachu,
    meta: {
      isPublic: true,
      title: "ピアチュウとは - ピアチュウ",
      description: "日本初！ ピアチュウとは、全国の中古ピアノ、販売店を比較検討して、試弾や購入申し込みができるサイトです",
    }
  },
  {
    path: '/seller_registration',
    component: SellerRegistration,
    meta: {
      isPublic: true,
      title: "ピアノ販売者の登録について - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/guideline_seller',
    component: GuidelineSeller,
    meta: {
      isPublic: true,
      title: "ピアノ販売者利用のガイドライン - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/guideline_review',
    component: GuidelineReview,
    meta: {
      isPublic: true,
      title: "評価投稿ガイドライン - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/prohibited_acts',
    component: ProhibitedActs,
    meta: {
      isPublic: true,
      title: "ピアチュウで禁止されている行為について - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/charge_user',
    component: ChargeUser,
    meta: {
      isPublic: true,
      title: "ユーザ利用料について - ピアチュウ",
      description: "登録・利用料は無料。中古ピアノを探されているユーザーの方は、アカウント登録やサイト利用について、費用は一切かかりません。申し込みやお気に入り登録機能などを、すべて無料で使うことができます。",
    }
  },
  {
    path: '/charge_seller',
    component: ChargeSeller,
    meta: {
      isPublic: true,
      title: "ユーザ利用料について - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/manager_info',
    component: ManagerInfo,
    meta: {
      isPublic: true,
      title: "運営情報 - ピアチュウ",
      description: "",
    }
  },
  {
    path: '/guideline_user',
    component: GuidelineUser,
    meta: {
      isPublic: true,
      title: "使い方について - ピアチュウ",
      description: "",
    }
  },
]

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to);
  if ( String(to.path).indexOf('evaluate') != -1 && to.query.tpe ) {
    localStorage.setItem("tpe", to.query.tpe);
  }
  // Store.commit('alert/setAlert', { 'message': '' });
  if (to.matched.some(page => page.meta.isPublic)) {
    if (Store.state.auth.token && to.path=='/login') {
      // if ( String(Store.state.auth.user_type) == "2" ) {
      //   next('/search/')
      // } else {
        next('/mypage')
      // }
    } else {
      next()
    }
  } else {
    if(Store.state.auth.token) {
      next()
    } else {
      localStorage.setItem("beforeUrl", location.pathname);
      next('/login')
    }
  }

})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    // console.log(to.meta.title);
    document.title = to.meta.title
  }
  if (to.meta && to.meta.description) {
    // console.log(to.meta.description);
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js